<template>
  <div class="app-container">
    <div class="filter-container" style="display: flex;flex-wrap: wrap;">
      <el-input v-model="listQuery.order_no" placeholder="请输入订单号" class="filter-item" style="width: 250px;" clearable />

      <el-input v-model="listQuery.sub_mch_id" placeholder="请输入特约商户号" class="filter-item" style="width: 200px;" clearable />

      <el-input v-model="listQuery.keyword" placeholder="请输入姓名、手机号码" class="filter-item" style="width: 200px;" clearable />

      <el-select v-model="listQuery.order_status" placeholder="订单状态" class="filter-item" style="width: 140px;" clearable>
        <el-option label="待支付" :value="0" />
        <el-option label="待发货" :value="1" />
        <el-option label="待收货" :value="2" />
        <el-option label="已完成" :value="3" />
        <el-option label="已取消" :value="4" />
      </el-select>

      <el-select v-model="listQuery.pay_status" placeholder="支付状态" class="filter-item" style="width: 140px;" clearable>
        <el-option label="待支付" :value="0" />
        <el-option label="已支付" :value="1" />
        <el-option label="已退款" :value="2" />
      </el-select>

      <el-select v-model="listQuery.refund_status" placeholder="退款状态" class="filter-item" style="width: 140px;" clearable>
        <el-option label="未申请" :value="0" />
        <el-option label="申请中" :value="1" />
        <el-option label="已通过" :value="2" />
        <el-option label="已拒绝" :value="3" />
      </el-select>

      <el-date-picker v-model="dateArr" type="daterange" value-format="yyyy-MM-dd" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" class="filter-item" style="display: flex;" clearable></el-date-picker>

      <el-button type="primary" class="filter-item" @click="handleFilter">搜索</el-button>

      <download-excel :fields="json_fields" :fetch="handleExport" type="xls" name="积分商城商品订单.xls" worksheet="积分商城商品订单">
        <el-button type="success" :loading="exportLoading">导出</el-button>
      </download-excel>
    </div>

    <div v-loading="listLoading" style="margin-bottom: 20px;">
      <el-row :gutter="20">
        <el-col :sm="4">
          <el-card class="box-card">
            <div class="value">{{ this.payPrice || 0 }}</div>
            <div class="subtitle">累计消费金额</div>
          </el-card>
        </el-col>
        <el-col :sm="4">
          <el-card class="box-card">
            <div class="value">{{ this.payPoints || 0 }}</div>
            <div class="subtitle">累计消费积分</div>
          </el-card>
        </el-col>
        <el-col :sm="4">
          <el-card class="box-card">
            <div class="value">{{ this.payCount || 0 }}</div>
            <div class="subtitle">累计消费次数</div>
          </el-card>
        </el-col>
        <el-col :sm="4">
          <el-card class="box-card">
            <div class="value">{{ this.refundPrice || 0 }}</div>
            <div class="subtitle">累计退款金额</div>
          </el-card>
        </el-col>
        <el-col :sm="4">
          <el-card class="box-card">
            <div class="value">{{ this.refundPoints || 0 }}</div>
            <div class="subtitle">累计退款积分</div>
          </el-card>
        </el-col>
        <el-col :sm="4">
          <el-card class="box-card">
            <div class="value">{{ this.refundCount || 0 }}</div>
            <div class="subtitle">累计退款次数</div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column label="订单号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.order_no }}
        </template>
      </el-table-column>

      <el-table-column label="特约商户号" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.sub_mch_id }}
        </template>
      </el-table-column>

      <el-table-column label="姓名" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.receiver.name }}
        </template>
      </el-table-column>

      <el-table-column label="手机号码" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.receiver.phone }}
        </template>
      </el-table-column>

      <el-table-column label="地址" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.receiver.address }}
        </template>
      </el-table-column>

      <el-table-column label="商品名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.details[0].goods_name }}
        </template>
      </el-table-column>

      <el-table-column label="商品封面" min-width="110" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.details[0].goods_cover" class="user-avatar">
        </template>
      </el-table-column>

      <el-table-column label="商品属性名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.details[0].goods_attr_name }}
        </template>
      </el-table-column>

      <el-table-column label="商品单价格" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.details[0].goods_unit_price  }}
        </template>
      </el-table-column>

      <el-table-column label="商品单积分" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.details[0].goods_unit_points }}
        </template>
      </el-table-column>

      <el-table-column label="商品数量" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.details[0].goods_num }}
        </template>
      </el-table-column>

      <el-table-column label="订单价格" min-width="110" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.total_price }}</div>
        </template>
      </el-table-column>

      <el-table-column label="订单积分" min-width="110" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.total_points }}</div>
        </template>
      </el-table-column>

      <el-table-column label="订单状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.order_status === 0">待支付</el-tag>
          <el-tag type="primary" v-else-if="scope.row.order_status === 1">待发货</el-tag>
          <el-tag type="warning" v-else-if="scope.row.order_status === 2">待收货</el-tag>
          <el-tag type="success" v-else-if="scope.row.order_status === 3">已完成</el-tag>
          <el-tag type="danger" v-else-if="scope.row.order_status === 4">已取消</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="支付状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.pay_status === 0">待支付</el-tag>
          <el-tag type="success" v-else-if="scope.row.pay_status === 1">已支付</el-tag>
          <el-tag type="warning" v-else-if="scope.row.pay_status === 2">已退款</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="退款状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.refund_status === 0">未申请</el-tag>
          <el-tag type="warning" v-else-if="scope.row.refund_status === 1">申请中</el-tag>
          <el-tag type="success" v-else-if="scope.row.refund_status === 2">已通过</el-tag>
          <el-tag type="danger" v-else-if="scope.row.refund_status === 3">已拒绝</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="退款拒绝原因" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.refund_status === 3 ? scope.row.refund_refuse_reason : "" }}
        </template>
      </el-table-column>

      <el-table-column label="取消时间" min-width="150" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.cancel_time }}</div>
        </template>
      </el-table-column>

      <el-table-column label="支付时间" min-width="150" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.pay_time }}</div>
        </template>
      </el-table-column>

      <el-table-column label="发货时间" min-width="150" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.send_time }}</div>
        </template>
      </el-table-column>

      <el-table-column label="物流单号" min-width="110" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.courier_no }}</div>
        </template>
      </el-table-column>

      <el-table-column label="物流公司" min-width="110" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.courier_company }}</div>
        </template>
      </el-table-column>

      <el-table-column label="收货时间" min-width="150" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.receive_time }}</div>
        </template>
      </el-table-column>

      <el-table-column label="下单时间" min-width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>

      <el-table-column label="操作" width="250" align="center" class-name="small-padding fixed-width" fixed="right">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" @click="handleCancel(scope.row)" :disabled="!(scope.row.order_status !== 3 && scope.row.order_status !== 4)">取消订单</el-button>

          <el-button type="primary" size="mini" @click="handleConfirmShipment(scope.row)" :disabled="!(scope.row.order_status === 1 && scope.row.refund_status !== 1)">确认发货</el-button>

          <el-button type="warning" size="mini" @click="handleRefundHandle(scope.row)" :disabled="!(scope.row.order_status === 1 && scope.row.refund_status === 1)">售后处理</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5, 10, 20, 30, 50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <!-- 确认发货 -->
    <el-dialog :visible.sync="dialogVisibleConfirmShipment" width="50%" :close-on-click-modal="false">
      <el-form ref="confirmShipmentForm" :rules="confirmShipmentRules" :model="confirmShipmentForm" label-width="150px">
        <el-form-item label="物流单号" prop="courier_no">
          <el-input v-model="confirmShipmentForm.courier_no"></el-input>
        </el-form-item>

        <el-form-item label="物流公司" prop="courier_company">
          <el-input v-model="confirmShipmentForm.courier_company"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleConfirmShipment = false">取消</el-button>
        <el-button type="primary" @click="saveDataConfirmShipment" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 确认发货 -->

    <!-- 售后处理 -->
    <el-dialog :visible.sync="dialogVisibleRefundHandle" width="50%" :close-on-click-modal="false">
      <el-form ref="refundHandleForm" :rules="refundHandleRules" :model="refundHandleForm" label-width="150px">
        <el-form-item label="处理状态" prop="handle_status">
          <el-radio-group v-model="refundHandleForm.handle_status">
            <el-radio :label="2">同意</el-radio>
            <el-radio :label="3">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="拒绝原因" prop="refund_refuse_reason" v-if="refundHandleForm.handle_status===3">
          <el-input v-model="refundHandleForm.refund_refuse_reason"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleRefundHandle = false">取消</el-button>
        <el-button type="primary" @click="saveDataRefundHandle" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 售后处理 -->
  </div>
</template>

<script>
import request from "@/utils/request";
import { mapGetters } from "vuex";
import downloadExcel from "vue-json-excel";
var moment = require("moment");

export default {
  components: {
    downloadExcel
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        school_id: "",
        order_no: "",
        sub_mch_id: "",
        keyword: "",
        order_status: "",
        pay_status: "",
        refund_status: "",
        start_date: "",
        end_date: "",
      },
      dateArr: null,
      payPrice: null,
      payPoints: null,
      payCount: null,
      refundPrice: null,
      refundPoints: null,
      refundCount: null,
      btnLoading: false,
      dialogVisibleConfirmShipment: false,
      confirmShipmentForm: {
        order_no: "",
        courier_no: "",
        courier_company: "",
      },
      confirmShipmentRules: {
        courier_no: [{ required: true, message: "物流单号不能为空", trigger: "change" }],
        courier_company: [{ required: true, message: "物流公司不能为空", trigger: "change" }],
      },
      dialogVisibleRefundHandle: false,
      refundHandleForm: {
        order_no: "",
        handle_status: "",
        refund_refuse_reason: "",
      },
      refundHandleRules: {
        handle_status: [{ required: true, message: "处理状态不能为空", trigger: "change" }],
      },
      json_fields: {
        订单号: {
          field: "order_no",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        特约商户号: {
          field: "sub_mch_id",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        姓名: {
          field: "receiver.name",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        手机号码: {
          field: "receiver.phone",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          },
        },
        地址: "receiver.address",
        商品名称: {
          field: "details",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value[0].goods_name + "</p>";
          },
        },
        商品属性名称: {
          field: "details",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value[0].goods_attr_name + "</p>";
          },
        },
        商品单价格: {
          field: "details",
          callback: (value) => {
            return value[0].goods_unit_price;
          },
        },
        商品单积分: {
          field: "details",
          callback: (value) => {
            return value[0].goods_unit_points;
          },
        },
        商品数量: {
          field: "details",
          callback: (value) => {
            return value[0].goods_num;
          },
        },
        订单价格: "total_price",
        订单积分: "total_points",
        订单状态: {
          field: "order_status",
          callback: (value) => {
            if (value === 0) return "待支付";
            else if (value === 1) return "待发货";
            else if (value === 2) return "待收货";
            else if (value === 3) return "已完成";
            else if (value === 4) return "已取消";
            else return "";
          }
        },
        支付状态: {
          field: "pay_status",
          callback: (value) => {
            if (value === 0) return "待支付";
            else if (value === 1) return "已支付";
            else if (value === 2) return "已退款";
            else return "";
          }
        },
        退款状态: {
          field: "refund_status",
          callback: (value) => {
            if (value === 0) return "未申请";
            else if (value === 1) return "申请中";
            else if (value === 2) return "已通过";
            else if (value === 3) return "已拒绝";
            else return "";
          }
        },
        退款拒绝原因: "refund_refuse_reason",
        取消时间: {
          field: "cancel_time",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        支付时间: {
          field: "pay_time",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        发货时间: {
          field: "send_time",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        物流单号: {
          field: "courier_no",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        物流公司: "courier_company",
        收货时间: {
          field: "receive_time",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
        下单时间: {
          field: "created_at",
          callback: (value) => {
            return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
          }
        },
      },
      exportLoading: false,
    };
  },
  created() {
    this.listQuery.start_date = moment().format("YYYY-MM-DD");
    this.listQuery.end_date = moment().format("YYYY-MM-DD");
    this.dateArr = [this.listQuery.start_date, this.listQuery.end_date];
    this.getList();
  },
  computed: {
    ...mapGetters(["schools", "school_id", "user"])
  },
  watch: {
    school_id(newVal, oldVal) {
      this.listQuery.school_id = newVal;
      this.getList();
    },
    dateArr(newVal, oldVal) {
      if (newVal) {
        this.listQuery.start_date = newVal[0];
        this.listQuery.end_date = newVal[1];
      } else {
        this.listQuery.start_date = "";
        this.listQuery.end_date = "";
      }
    }
  },
  methods: {
    getList() {
      this.listQuery.school_id = this.school_id;
      this.listLoading = true;
      request({
        url: "/api/backend/mallGoodsOrder/list",
        method: "get",
        params: this.listQuery,
        timeout: 6000000,
      }).then((response) => {
        this.list = response.data.list.data;
        this.total = response.data.list.total;
        this.payPrice = response.data.payPrice;
        this.payPoints = response.data.payPoints;
        this.payCount = response.data.payCount;
        this.refundPrice = response.data.refundPrice;
        this.refundPoints = response.data.refundPoints;
        this.refundCount = response.data.refundCount;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleCancel(item){
      this.$confirm("确定要取消订单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        request({
          url: "/api/backend/mallGoodsOrder/cancel",
          method: "post",
          data: {
            order_no: item.order_no
          }
        }).then(() => {
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          this.getList();
        });
      });
    },
    // 确认发货
    handleConfirmShipment(item) {
      this.confirmShipmentForm = {
        order_no: item.order_no,
        courier_no: "",
        courier_company: "",
      }
      this.dialogVisibleConfirmShipment = true;
      this.$nextTick(() => {
        this.$refs["confirmShipmentForm"].clearValidate() //清除校验结果
      })
    },
    saveDataConfirmShipment() {
      if (!this.confirmShipmentForm.order_no) {
        this.$message({
          type: "warning",
          message: "订单号不能为空",
        });
        return;
      }

      this.$refs["confirmShipmentForm"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/mallGoodsOrder/confirmShipment",
            method: "post",
            data: this.confirmShipmentForm
          }).then(() => {
            this.dialogVisibleConfirmShipment = false;
            this.$message({
              type: "success",
              message: "操作成功!"
            });
            this.getList();
          }).finally(() => {
            this.btnLoading = false;
          });
        }
      });
    },
    // 售后处理
    handleRefundHandle(item) {
      this.refundHandleForm = {
        order_no: item.order_no,
        handle_status: "",
        refund_refuse_reason: "",
      }
      this.dialogVisibleRefundHandle = true;
      this.$nextTick(() => {
        this.$refs["refundHandleForm"].clearValidate() //清除校验结果
      })
    },
    saveDataRefundHandle() {
      if (!this.refundHandleForm.order_no) {
        this.$message({
          type: "warning",
          message: "订单号不能为空",
        });
        return;
      }
      if (this.refundHandleForm.handle_status === 3 && !this.refundHandleForm.refund_refuse_reason) {
        this.$message({
          type: "warning",
          message: "拒绝原因不能为空",
        });
        return;
      }

      this.$refs["refundHandleForm"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/mallGoodsOrder/refundHandle",
            method: "post",
            data: this.refundHandleForm
          }).then(() => {
            this.dialogVisibleRefundHandle = false;
            this.$message({
              type: "success",
              message: "操作成功!"
            });
            this.getList();
          }).finally(() => {
            this.btnLoading = false;
          });
        }
      });
    },
    handleExport() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      listQuery.page = 1;
      listQuery.limit = this.total;
      this.exportLoading = true;
      return request({
        url: "/api/backend/mallGoodsOrder/list",
        method: "get",
        params: listQuery,
        timeout: 6000000,
      }).then(response => {
        if (response.data.list.data.length <= 0) {
          this.$message({
            type: "warning",
            message: "暂无记录"
          });
          return;
        }
        return response.data.list.data;
      }).catch((err) => {
        console.log(err);
      }).finally(() => {
        this.exportLoading = false;
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .box-card {
    text-align: center;
    .value {
      color: #546DFE;
      font-weight: bold;
      font-size: 26px;
    }
    .subtitle {
      font-size: 12px;
      color: gray;
      margin-top: 6px;
    }
  }
  .user-avatar {
    width: 60px;
    height: 60px;
    border-radius: 6px;
  }
</style>
